<template>
	<TheForm
		:model="loginForm"
		:rules="rules"
		:id="id"
		ref="formRef"
		:waiting="waiting"
		:showErr="showErr"
		:errMsg="texts.formErrors.loginFailed"
		:submitFunc="submitForm"
	>
		<el-form-item label="E-Mail" prop="email">
			<el-input v-model="loginForm.email" placeholder="E-Mail" />
		</el-form-item>
		<el-form-item label="Passwort" prop="password" id="password">
			<el-input type="password" v-model="loginForm.password" placeholder="Passwort" show-password />
		</el-form-item>

		<el-form-item>
			<TheButton @buttonclick="$emit('wantsToResetPassword')" :text="true"> Passwort vergessen? </TheButton>
		</el-form-item>
	</TheForm>
	<div class="button-panel">
		<TheButton @buttonclick="submitForm()" :loading="waiting" type="danger" isSubmit>Login</TheButton>
		<!-- <TheButton @buttonclick="submitForm(true)" :loading="waiting" type="danger" v-if="store.state.environment === 'development'">
			Superuser Login
		</TheButton> -->
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { FormInstance } from 'element-plus';
import TheButton from '../../components/TheButton.vue';
import TheForm from '../TheForm.vue';
import { texts } from '../../utils/texts';
import { login } from '../../requests/auth';
import { getCurrentUser } from '../../requests/users';
import { validateForm, validatePassword } from '../../utils/functions';
import { useStore } from '../../store';

export default defineComponent({
	name: 'LoginForm',
	components: {
		TheButton,
		TheForm,
	},
	emits: ['wantsToResetPassword'],
	setup() {
		const store = useStore();
		const router = useRouter();
		const formRef = ref<FormInstance>();
		const waiting = ref(false);
		const showErr = ref(false);
		const loginForm = ref({
			email: '',
			password: '',
		});

		const rules = {
			email: [
				{ required: true, message: texts.formErrors.emailReq, trigger: 'blur' },
				{ type: 'email', message: texts.formErrors.emailMissing, trigger: ['blur'] },
			],
			password: [
				{ required: true, message: texts.formErrors.pwReq, trigger: 'blur' },
				{ validator: validatePassword, trigger: 'blur' },
			],
		};

		const submitForm = async (development: boolean = false) => {
			const isValid = await validateForm(formRef.value, 'loginform');
			if (!isValid && !development) return;

			waiting.value = true;
			showErr.value = false;

			try {
				const loginResult = await login(
					{
						email: loginForm.value.email,
						password: loginForm.value.password,
					},
					true,
					false,
				);

				if (loginResult.success) {
					const userResult = await getCurrentUser();

					if (userResult.success) {
						store.dispatch('setUser', userResult.data);
						store.dispatch('login', true);

						// Redirect logic
						const intendedUrl = store.state.intendedUrl;
						if (intendedUrl) {
							store.dispatch('setIntendedUrl', null);
							router.push(intendedUrl);
						} else {
							router.push({ name: 'Dashboard' });
						}
					}
				} else {
					showErr.value = true;
				}
			} catch (error) {
				console.error('Login error:', error);
				showErr.value = true;
			} finally {
				waiting.value = false;
			}
		};

		return {
			store,
			formRef,
			waiting,
			showErr,
			loginForm,
			rules,
			submitForm,
			texts: computed(() => texts),
			id: 'loginform',
		};
	},
});
</script>
